export function fileHasExtension(fileName: string, validExtensions: Array<string>): boolean {
    const FILE_EXTENSION_REGEX = /\.([0-9a-z]+)(?:[?#]|$)/i;
    const matches = fileName.match(FILE_EXTENSION_REGEX);
    const fileExt = matches && matches.length ? matches[1].toLowerCase() : undefined;
    const parsedExtensions = validExtensions.reduce((valid, ext) => {
        if (ext && ext.length > 0) {
            // Strip any dots and turn it to lower case
            valid.push(ext.replace('.', '').toLowerCase());
        }
        return valid;
    }, []);
    return parsedExtensions.includes(fileExt);
}

export async function isValidFeatureLayerFile(file): Promise<Error> {
    const fileToBigErrorMsg = 'Failed to attach file, file exceeds size limit of 2MB';
    const fileNotFeatureLayerFileErrorMsg = 'Not an KML/KMZ file (must end in .kml or .kmz)';
    const fileFailedToAttachErrorMsg = 'Failed to attach file';

    // Check we have a file at all
    if (!file) {
        return new Error(fileFailedToAttachErrorMsg);
    }

    // File should really not be larger than 2MB for now
    if (file.size > 2097152) {
        return new Error(fileToBigErrorMsg);
    }

    // Check if this is a valid ant file
    if (!fileHasExtension(file.name, ['kml', 'kmz'])) {
        return new Error(fileNotFeatureLayerFileErrorMsg);
    }

    // TODO check if file type matches the selected extension? maybe auto set the type???

    // Read the file using some strange promise callback conversion
    const reader = new (window as any).FileReader();
    const readerPromise = new Promise((resolve, reject) => {
        reader.onload = resolve;
        reader.onerror = reject;
    }) as any;
    reader.readAsDataURL(file);
    const readerEvent = await readerPromise;
    file.fileData = readerEvent.target.result.split(',')[1];

    // No errors, return
    return undefined;
}
